var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibraryCategoryLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H52M1 27H52M1 53H52M1 7.5C1 6.39543 1.89543 5.5 3 5.5H19C20.1046 5.5 21 6.39543 21 7.5V21.5C21 22.6046 20.1046 23.5 19 23.5H3C1.89543 23.5 1 22.6046 1 21.5V7.5ZM23 7.5C23 6.39543 23.8954 5.5 25 5.5H41C42.1046 5.5 43 6.39543 43 7.5V21.5C43 22.6046 42.1046 23.5 41 23.5H25C23.8954 23.5 23 22.6046 23 21.5V7.5ZM45 7.5C45 6.39543 45.8954 5.5 47 5.5H52V23.5H47C45.8954 23.5 45 22.6046 45 21.5V7.5ZM17 32.5C17 31.3954 17.8954 30.5 19 30.5H35C36.1046 30.5 37 31.3954 37 32.5V46.5C37 47.6046 36.1046 48.5 35 48.5H19C17.8954 48.5 17 47.6046 17 46.5V32.5ZM39 32.5C39 31.3954 39.8954 30.5 41 30.5H50C51.1046 30.5 52 31.3954 52 32.5V46.5C52 47.6046 51.1046 48.5 50 48.5H41C39.8954 48.5 39 47.6046 39 46.5V32.5ZM1 30.5H13C14.1046 30.5 15 31.3954 15 32.5V46.5C15 47.6046 14.1046 48.5 13 48.5H1V30.5Z",
    fill: "#D9DDE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryCategoryLayout);
export default __webpack_public_path__ + "static/media/library-category-layout.8af1034033966b009005bcdc39c0031b.svg";
export { ForwardRef as ReactComponent };